// import React, { useMemo, useState } from "react";
// import { useSelector } from "react-redux";
// import "./DashboardList.css";
// import DashboardView from "../DashboardView";
// import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
// import DashboardIcon from "../../assets/icons/grid-icon.svg";
// import ReportIcon from "../../assets/icons/reports.svg";
// import GroupIcon from "../../assets/icons/group-icon.svg";

// const DashboardList = () => {
//   const boards = useSelector((state) => state.boards.boardsData || []);
//   const groups = useSelector((state) => state.boards.groups || []);
//   const apps = useSelector((state) => state.user.apps?.Result || []);
//   const isLoading = useSelector((state) => state.boards.isLoading ?? state.boards.loading ?? false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [viewMode, setViewMode] = useState("list"); // "grid" | "list"
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filterApp, setFilterApp] = useState("all");
//   const [filterGroup, setFilterGroup] = useState("all");
//   const [filterType, setFilterType] = useState("all");

//   const itemsPerPage = 10;

//   const groupMap = useMemo(() => new Map(groups.map((g) => [g.id, g.title])), [groups]);
//   const appMap = useMemo(() => new Map(apps.map((a) => [a.ApplicationID, a.Name])), [apps]);

//   const uniqueApps = useMemo(() => [...new Set(apps.map((a) => a.Name))], [apps]);
//   const uniqueGroups = useMemo(() => [...new Set(groups.map((g) => g.title))], [groups]);

//   const rows = useMemo(
//     () =>
//       boards.map((board, index) => {
//         const appNames = Array.isArray(board.appList) ? board.appList.map((id) => appMap.get(id) || id).join(", ") : "";
//         const groupName = groupMap.get(board.configDetails?.groupId) || "Unassigned";
//         const typeLabel = board.configDetails?.boardType === "reports" ? "Report" : "Dashboard";
//         const statusLabel = board.publish === false ? "Draft" : "Active";
//         const createdAt = board.createdAt || board.updatedAt || "";
//         const createdText = createdAt
//           ? new Date(createdAt).toLocaleDateString("en-CA", {
//               year: "numeric",
//               month: "2-digit",
//               day: "2-digit",
//             }) +
//             " " +
//             new Date(createdAt).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
//           : "";
//         const visibility = board.configDetails?.isPublic || board.configDetails?.isPuplic ? "Public" : "Private";

//         return {
//           key: board.id || index,
//           boardId: board.id,
//           name: board.name || "Untitled",
//           appNames: appNames || "—",
//           groupName,
//           typeLabel,
//           statusLabel,
//           createdText,
//           visibility,
//         };
//       }),
//     [boards, appMap, groupMap],
//   );

//   console.log("rows", boards);

//   const filteredRows = useMemo(
//     () =>
//       rows.filter((row) => {
//         const matchSearch = row.name.toLowerCase().includes(searchQuery.toLowerCase());
//         const matchApp = filterApp === "all" || row.appNames === filterApp;
//         const matchGroup = filterGroup === "all" || row.groupName === filterGroup;
//         const matchType = filterType === "all" || row.typeLabel.toLowerCase() === filterType;
//         return matchSearch && matchApp && matchGroup && matchType;
//       }),
//     [rows, searchQuery, filterApp, filterGroup, filterType],
//   );

//   const totalPages = Math.ceil(filteredRows.length / itemsPerPage);
//   const startIdx = (currentPage - 1) * itemsPerPage;
//   const endIdx = startIdx + itemsPerPage;
//   const paginatedRows = filteredRows.slice(startIdx, endIdx);

//   const handleMenuToggle = (rowId, e) => {
//     e.stopPropagation();
//     setOpenMenuId(openMenuId === rowId ? null : rowId);
//   };

//   const handleMenuAction = (action, boardId) => {
//     console.log(`Action: ${action}, Board ID: ${boardId}`);
//     setOpenMenuId(null);
//     // TODO: Implement view/edit/delete actions
//   };

//   // close menu on outside click
//   const handleTableClick = () => setOpenMenuId(null);

//   const today = new Date().toLocaleDateString("en-US", {
//     weekday: "long",
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   });

//   return (
//     <DashboardView>
//       {isLoading && <LoadingOverlay text="Loading dashboards..." />}

//       <div className="dbl-shell" onClick={handleTableClick}>
//         {/* Header */}
//         <div className="dbl-header">
//           <div className="dbl-header-left">
//             <h1 className="dbl-title">Dashboards</h1>
//             <p className="dbl-subtitle">{today}</p>
//           </div>
//           <button className="dbl-create-btn">+ Create New</button>
//         </div>

//         {/* Controls */}
//         <div className="dbl-controls">
//           <div className="dbl-search-wrap">
//             <svg
//               className="dbl-search-icon"
//               viewBox="0 0 20 20"
//               fill="none"
//               width="16"
//               height="16"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <circle cx="8.5" cy="8.5" r="5.5" stroke="#9ca3af" strokeWidth="1.5" />
//               <path d="M13 13l3 3" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" />
//             </svg>
//             <input
//               className="dbl-search-input"
//               type="text"
//               placeholder="Search dashboards..."
//               value={searchQuery}
//               onChange={(e) => {
//                 setSearchQuery(e.target.value);
//                 setCurrentPage(1);
//               }}
//             />
//           </div>

//           <div className="dbl-filters">
//             <select
//               className="dbl-select"
//               value={filterApp}
//               onChange={(e) => {
//                 setFilterApp(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="all">All Application</option>
//               {uniqueApps.map((a) => (
//                 <option key={a} value={a}>
//                   {a}
//                 </option>
//               ))}
//             </select>

//             <select
//               className="dbl-select"
//               value={filterGroup}
//               onChange={(e) => {
//                 setFilterGroup(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="all">All Groups</option>
//               {uniqueGroups.map((g) => (
//                 <option key={g} value={g}>
//                   {g}
//                 </option>
//               ))}
//             </select>

//             <select
//               className="dbl-select"
//               value={filterType}
//               onChange={(e) => {
//                 setFilterType(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="all">All Types</option>
//               <option value="dashboard">Dashboard</option>
//               <option value="report">Report</option>
//             </select>

//             {/* View toggle */}
//             <div className="dbl-view-toggle">
//               <button
//                 className={`dbl-toggle-btn ${viewMode === "grid" ? "active" : ""}`}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setViewMode("grid");
//                 }}
//                 title="Grid view"
//               >
//                 <svg viewBox="0 0 16 16" fill="currentColor" width="15" height="15">
//                   <rect x="1" y="1" width="6" height="6" rx="1" />
//                   <rect x="9" y="1" width="6" height="6" rx="1" />
//                   <rect x="1" y="9" width="6" height="6" rx="1" />
//                   <rect x="9" y="9" width="6" height="6" rx="1" />
//                 </svg>
//               </button>
//               <button
//                 className={`dbl-toggle-btn ${viewMode === "list" ? "active" : ""}`}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setViewMode("list");
//                 }}
//                 title="List view"
//               >
//                 <svg viewBox="0 0 16 16" fill="currentColor" width="15" height="15">
//                   <rect x="1" y="2" width="14" height="2" rx="1" />
//                   <rect x="1" y="7" width="14" height="2" rx="1" />
//                   <rect x="1" y="12" width="14" height="2" rx="1" />
//                 </svg>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Table */}
//         <div className="dbl-table-wrap">
//           <table className="dbl-table">
//             <thead className="dbl-thead">
//               <tr>
//                 <th className="dbl-th">Name</th>
//                 <th className="dbl-th">Application</th>
//                 <th className="dbl-th">Group</th>
//                 <th className="dbl-th">Type</th>
//                 <th className="dbl-th">Status</th>
//                 <th className="dbl-th">Created</th>
//                 <th className="dbl-th dbl-th-action"></th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredRows.length > 0 ? (
//                 paginatedRows.map((row) => (
//                   <tr key={row.key} className="dbl-tr">
//                     {/* Name */}
//                     <td className="dbl-td">
//                       <div className="dbl-name-cell">
//                         <span
//                           className={`dbl-type-icon ${row.typeLabel === "Report" ? "dbl-icon-report" : "dbl-icon-dashboard"}`}
//                         >
//                           {row.typeLabel === "Report" ? (
//                             <img
//                               src={ReportIcon}
//                               alt="report-icon"
//                               width={20}
//                               height={20}
//                               className="dbl-type-report-icon"
//                             />
//                           ) : (
//                             // <svg viewBox="0 0 16 16" fill="currentColor" width="14" height="14">
//                             //   <path d="M3 2a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V2zm2 1v10h6V3H5zm1 2h4v1H6V5zm0 2h4v1H6V7zm0 2h2v1H6V9z" />
//                             // </svg>
//                             <img
//                               src={DashboardIcon}
//                               alt="dashboard-icon"
//                               width={20}
//                               height={20}
//                               className="dbl-type-dashboard-icon"
//                             />
//                           )}
//                         </span>
//                         <div>
//                           <div className="dbl-name-text">{row.name}</div>
//                           <div
//                             className={`dbl-visibility-badge ${row.visibility === "Public" ? "dbl-vis-public" : "dbl-vis-private"}`}
//                           >
//                             {row.visibility === "Public" ? (
//                               <img src={GroupIcon} alt="group-icon" height={16} />
//                             ) : (
//                               <svg viewBox="0 0 12 12" fill="currentColor" width="9" height="9">
//                                 <path d="M6 1a3 3 0 00-3 3v1H2v6h8V5H9V4a3 3 0 00-3-3zm0 1.5A1.5 1.5 0 017.5 4v1h-3V4A1.5 1.5 0 016 2.5z" />
//                               </svg>
//                             )}
//                             {row.visibility}
//                           </div>
//                         </div>
//                       </div>
//                     </td>

//                     <td className="dbl-td dbl-td-muted">{row.appNames}</td>
//                     <td className="dbl-td dbl-td-muted">{row.groupName}</td>

//                     {/* Type pill */}
//                     <td className="dbl-td">
//                       <span
//                         className={`dbl-type-pill ${row.typeLabel === "Report" ? "dbl-pill-report" : "dbl-pill-dashboard"}`}
//                       >
//                         {row.typeLabel}
//                       </span>
//                     </td>

//                     {/* Status pill */}
//                     <td className="dbl-td">
//                       <span className={`dbl-status-pill dbl-status-${row.statusLabel.toLowerCase()}`}>
//                         <span className="dbl-status-dot" />
//                         {row.statusLabel}
//                       </span>
//                     </td>

//                     <td className="dbl-td dbl-td-muted">{row.createdText}</td>

//                     {/* Action menu */}
//                     <td className="dbl-td dbl-td-action">
//                       <div className="dbl-action-wrap">
//                         <button className="dbl-action-btn" onClick={(e) => handleMenuToggle(row.key, e)}>
//                           ⋮
//                         </button>
//                         {openMenuId === row.key && (
//                           <div className="dbl-action-menu" onClick={(e) => e.stopPropagation()}>
//                             <button className="dbl-menu-item" onClick={() => handleMenuAction("view", row.boardId)}>
//                               <svg
//                                 viewBox="0 0 16 16"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="1.5"
//                                 width="13"
//                                 height="13"
//                               >
//                                 <circle cx="8" cy="8" r="3" />
//                                 <path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" />
//                               </svg>
//                               View
//                             </button>
//                             <button className="dbl-menu-item" onClick={() => handleMenuAction("edit", row.boardId)}>
//                               <svg
//                                 viewBox="0 0 16 16"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="1.5"
//                                 width="13"
//                                 height="13"
//                               >
//                                 <path d="M11 2l3 3-8 8H3v-3l8-8z" />
//                               </svg>
//                               Edit
//                             </button>
//                             <button
//                               className="dbl-menu-item dbl-menu-item-danger"
//                               onClick={() => handleMenuAction("delete", row.boardId)}
//                             >
//                               <svg
//                                 viewBox="0 0 16 16"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="1.5"
//                                 width="13"
//                                 height="13"
//                               >
//                                 <path d="M2 4h12M5 4V2h6v2M6 7v5M10 7v5M3 4l1 9h8l1-9" />
//                               </svg>
//                               Delete
//                             </button>
//                           </div>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="7" className="dbl-empty">
//                     {isLoading ? "" : "No dashboards or reports found."}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {filteredRows.length > 0 && (
//           <div className="dbl-pagination">
//             <span className="dbl-pagination-info">
//               Showing {startIdx + 1} to {Math.min(endIdx, filteredRows.length)} of {filteredRows.length} results
//             </span>
//             <div className="dbl-pagination-btns">
//               <button
//                 className="dbl-page-btn"
//                 onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
//                 disabled={currentPage === 1}
//               >
//                 ‹
//               </button>
//               {Array.from({ length: totalPages }, (_, i) => (
//                 <button
//                   key={i + 1}
//                   className={`dbl-page-btn ${currentPage === i + 1 ? "dbl-page-active" : ""}`}
//                   onClick={() => setCurrentPage(i + 1)}
//                 >
//                   {i + 1}
//                 </button>
//               ))}
//               <button
//                 className="dbl-page-btn"
//                 onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
//                 disabled={currentPage === totalPages}
//               >
//                 ›
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </DashboardView>
//   );
// };

// export default DashboardList;
import React, { useMemo, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { message } from "antd";
import "./DashboardList.css";
import DashboardView from "../DashboardView";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
import ConfirmDialog from "../../components/common/ConfirmDialog";
/* Feather set - thin, evenly weighted strokes, which is what the rest of this page
   already uses. Hand-drawn paths were fine but drifted in weight between icons. */
import { FiEye, FiEdit2, FiTrash2 } from "react-icons/fi";
import DashboardIcon from "../../assets/icons/grid-icon.svg";
/* Imported as a component, not a URL: reports.svg carries a hardcoded fill="#0369A1",
   and an <img> cannot be recoloured from CSS. Inlined, a CSS `fill` overrides that
   presentation attribute. The shared file is left alone - Groups renders the same
   icon and still wants the blue. */
import { ReactComponent as ReportIcon } from "../../assets/icons/reports.svg";
import GroupIcon from "../../assets/icons/group-icon.svg";
import { updateSelectedBoard, deleteBoardByIdAsync, getBoardsAsync, resetBoardData } from "../../redux/boardSlice";

const DashboardList = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const boards = useSelector((state) => state.boards.boardsData || []);
  const groups = useSelector((state) => state.boards.groups || []);
  const apps = useSelector((state) => state.user.apps?.Result || []);
  // The boards slice tracks its request through boardsStatus — it has no isLoading /
  // loading field, so the old selector was always false and the empty state showed
  // while the fetch was still in flight. "default" means DashboardView has not
  // dispatched getBoards yet, which reads as loading from here too.
  const boardsStatus = useSelector((state) => state.boards.boardsStatus);
  const isLoading = boardsStatus === "pending" || boardsStatus === "default";
  const accessToken = useSelector((state) => state.user?.user?.accessToken);
  const currentAppPermissions = useSelector((state) => state.user.currentAppPermissions || []);

  // Same gate the old board header used: Edit/Delete were wrapped in an
  // `IsSpecialUser === "true"` check and additionally disabled without the
  // CreateDashboard permission. (See the commented block in views/Dashboard/index.js.)
  const isSpecialUser = localStorage.getItem("IsSpecialUser") === "true";
  const canManageBoards = isSpecialUser || currentAppPermissions.indexOf("CreateDashboard") !== -1;

  const [currentPage, setCurrentPage] = useState(1);
  const [openMenuId, setOpenMenuId] = useState(null);
  // Viewport coordinates for the open action menu. It is portalled to <body> because
  // .dbl-table-wrap scrolls horizontally, and an overflow container clips any
  // absolutely-positioned child — which is what cut the menu off on the last rows.
  const [menuPos, setMenuPos] = useState(null);
  const [viewMode, setViewMode] = useState("list");
  const [searchQuery, setSearchQuery] = useState("");
  const [filterApp, setFilterApp] = useState("all");
  const [filterGroup, setFilterGroup] = useState("all");
  const [filterType, setFilterType] = useState("all");
  // the board awaiting delete confirmation; null when the dialog is closed
  const [pendingDelete, setPendingDelete] = useState(null);

  const itemsPerPage = viewMode === "grid" ? 9 : 10;

  const groupMap = useMemo(() => new Map(groups.map((g) => [g.id, g.title])), [groups]);
  const appMap = useMemo(() => new Map(apps.map((a) => [a.ApplicationID, a.Name])), [apps]);

  const uniqueApps = useMemo(() => [...new Set(apps.map((a) => a.Name))], [apps]);
  const uniqueGroups = useMemo(() => [...new Set(groups.map((g) => g.title))], [groups]);

  const rows = useMemo(
    () =>
      boards.map((board, index) => {
        const appNames = Array.isArray(board.appList) ? board.appList.map((id) => appMap.get(id) || id).join(", ") : "";
        const groupName = groupMap.get(board.configDetails?.groupId) || "Unassigned";
        const typeLabel = board.configDetails?.boardType === "reports" ? "Report" : "Dashboard";
        const statusLabel = board.publish === false ? "Draft" : "Active";
        const createdAt = board.createdAt || board.updatedAt || "";
        const createdText = createdAt
          ? new Date(createdAt).toLocaleDateString("en-CA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }) +
            " " +
            new Date(createdAt).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
          : "";
        const visibility = board.configDetails?.isPublic || board.configDetails?.isPuplic ? "Public" : "Private";

        return {
          key: board.id || index,
          boardId: board.id,
          board, // kept so View can seed selectedBoard the way the old sidebar tree did
          boardType: board.configDetails?.boardType === "reports" ? "reports" : "dashboard",
          name: board.name || "Untitled",
          appNames: appNames || "—",
          groupName,
          typeLabel,
          statusLabel,
          createdText,
          visibility,
        };
      }),
    [boards, appMap, groupMap],
  );

  const filteredRows = useMemo(
    () =>
      rows.filter((row) => {
        const matchSearch = row.name.toLowerCase().includes(searchQuery.toLowerCase());
        const matchApp = filterApp === "all" || row.appNames === filterApp;
        const matchGroup = filterGroup === "all" || row.groupName === filterGroup;
        const matchType = filterType === "all" || row.typeLabel.toLowerCase() === filterType;
        return matchSearch && matchApp && matchGroup && matchType;
      }),
    [rows, searchQuery, filterApp, filterGroup, filterType],
  );

  const totalPages = Math.ceil(filteredRows.length / itemsPerPage);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedRows = filteredRows.slice(startIdx, endIdx);

  const closeMenu = () => {
    setOpenMenuId(null);
    setMenuPos(null);
  };

  const handleMenuToggle = (rowId, e) => {
    e.stopPropagation();
    if (openMenuId === rowId) {
      closeMenu();
      return;
    }
    const rect = e.currentTarget.getBoundingClientRect();
    const menuWidth = 150;
    const menuHeight = (canManageBoards ? 3 : 1) * 38 + 10;
    // Flip above the button when the last rows would push the menu off-screen.
    const openUpward = rect.bottom + menuHeight + 8 > window.innerHeight;
    setMenuPos({
      top: openUpward ? Math.max(8, rect.top - menuHeight - 4) : rect.bottom + 4,
      left: Math.max(8, Math.min(rect.right - menuWidth, window.innerWidth - menuWidth - 8)),
      width: menuWidth,
    });
    setOpenMenuId(rowId);
  };

  // A fixed-position menu would drift away from its button on scroll, so close it instead.
  // Capture phase catches scrolling inside the table wrapper too, not just the window.
  // The document listener handles clicks anywhere outside the page shell (sidebar,
  // top bar, …), which the shell's own onClick never sees.
  useEffect(() => {
    if (!openMenuId) return undefined;
    const close = () => closeMenu();
    const onDocumentMouseDown = (e) => {
      // Ignore the ⋮ button itself and the menu — otherwise mousedown would close
      // the menu a moment before click reopens it, and toggling off would never work.
      if (e.target.closest && e.target.closest(".dbl-action-wrap, .dbl-action-menu")) return;
      closeMenu();
    };
    document.addEventListener("mousedown", onDocumentMouseDown);
    window.addEventListener("scroll", close, true);
    window.addEventListener("resize", close);
    return () => {
      document.removeEventListener("mousedown", onDocumentMouseDown);
      window.removeEventListener("scroll", close, true);
      window.removeEventListener("resize", close);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openMenuId]);

  /* View — same destination the old sidebar tree used: /board/:id for dashboards,
     /report/:id for reports. Seeding selectedBoard first keeps the title from
     flashing empty while getBoardByIdAsync is in flight. */
  const handleViewBoard = (row) => {
    closeMenu();
    if (!row.boardId) return;
    if (row.board) dispatch(updateSelectedBoard(row.board));
    history.push(`${row.boardType === "reports" ? "/report/" : "/board/"}${row.boardId}`);
  };

  /* Edit — the editor reads the board off the :selectedId segment
     (Editor/index.js -> getDashboardDetailsAsync). The :id segment is only the type. */
  const handleEditBoard = (row) => {
    closeMenu();
    if (!row.boardId) return;
    history.push(`/editor/${row.boardType}/${row.boardId}`);
  };

  /* Delete — the reducer only flips boardDeleteState, it does not drop the board
     from boardsData, so the list is refetched once the request resolves. */
  /* Asks through the shared ConfirmDialog instead of Modal.confirm, so this looks like
     every other confirmation in the app. The row is parked in state and the dialog is
     rendered once at the bottom of the view. */
  const handleDeleteBoard = (row) => {
    closeMenu();
    if (!row.boardId) return;
    setPendingDelete(row);
  };

  const confirmDeleteBoard = () => {
    const row = pendingDelete;
    setPendingDelete(null);
    if (!row?.boardId) return;

    // RTK 1.5.1 has no promise.unwrap(), so the resolved action carries the outcome.
    dispatch(deleteBoardByIdAsync(row.boardId)).then((action) => {
      if (action.error) {
        message.error(`Oops, ${row.typeLabel} is not deleted!`);
        return;
      }
      message.success(`${row.typeLabel} deleted successfully!`);
      // boardDeleteState stays "success" otherwise, and the board view bounces
      // straight back to Home the next time it mounts.
      dispatch(resetBoardData());
      dispatch(getBoardsAsync(accessToken));
    });
  };

  const handleMenuAction = (action, row) => {
    if (action === "view") return handleViewBoard(row);
    if (action === "edit") return handleEditBoard(row);
    if (action === "delete") return handleDeleteBoard(row);
  };

  const handleTableClick = () => closeMenu();

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
    setCurrentPage(1);
    closeMenu();
  };

  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  /* ── Shared sub-components ──────────────────────────── */
  const TypeIcon = ({ typeLabel }) => (
    <span className={`dbl-type-icon ${typeLabel === "Report" ? "dbl-icon-report" : "dbl-icon-dashboard"}`}>
      {typeLabel === "Report" ? (
        <ReportIcon width={20} height={20} role="img" aria-label="report-icon" />
      ) : (
        <img src={DashboardIcon} alt="dashboard-icon" width={20} height={20} />
      )}
    </span>
  );

  const VisibilityBadge = ({ visibility }) => (
    <div className={`dbl-visibility-badge ${visibility === "Public" ? "dbl-vis-public" : "dbl-vis-private"}`}>
      {visibility === "Public" ? (
        <img src={GroupIcon} alt="group-icon" height={15} />
      ) : (
        <svg viewBox="0 0 12 12" fill="currentColor" width="9" height="9">
          <path d="M6 1a3 3 0 00-3 3v1H2v6h8V5H9V4a3 3 0 00-3-3zm0 1.5A1.5 1.5 0 017.5 4v1h-3V4A1.5 1.5 0 016 2.5z" />
        </svg>
      )}
      {visibility}
    </div>
  );

  const StatusPill = ({ statusLabel }) => (
    <span className={`dbl-status-pill dbl-status-${statusLabel.toLowerCase()}`}>
      <span className="dbl-status-dot" />
      {statusLabel}
    </span>
  );

  const TypePill = ({ typeLabel }) => (
    <span className={`dbl-type-pill ${typeLabel === "Report" ? "dbl-pill-report" : "dbl-pill-dashboard"}`}>
      {typeLabel}
    </span>
  );

  const ActionMenu = ({ row }) => (
    <div className="dbl-action-wrap">
      <button className="dbl-action-btn" onClick={(e) => handleMenuToggle(row.key, e)}>
        ⋮
      </button>
      {openMenuId === row.key &&
        menuPos &&
        ReactDOM.createPortal(
          <div
            className="dbl-action-menu"
            style={{ top: menuPos.top, left: menuPos.left, minWidth: menuPos.width }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="dbl-menu-item" onClick={() => handleMenuAction("view", row)}>
              <FiEye size={14} aria-hidden="true" />
              View
            </button>
            {/* Edit/Delete stay hidden for users without board rights, as in the old header. */}
            {/* {canManageBoards && (
              <>
                <button className="dbl-menu-item" onClick={() => handleMenuAction("edit", row)}>
                  <FiEdit2 size={14} aria-hidden="true" />
                  Edit
                </button>
                <button className="dbl-menu-item dbl-menu-item-danger" onClick={() => handleMenuAction("delete", row)}>
                  <FiTrash2 size={14} aria-hidden="true" />
                  Delete
                </button>
              </>
            )} */}
            <button className="dbl-menu-item" onClick={() => handleMenuAction("edit", row)}>
              <FiEdit2 size={14} aria-hidden="true" />
              Edit
            </button>
            <button className="dbl-menu-item dbl-menu-item-danger" onClick={() => handleMenuAction("delete", row)}>
              <FiTrash2 size={14} aria-hidden="true" />
              Delete
            </button>
          </div>,
          document.body,
        )}
    </div>
  );

  /* ── Loading skeletons ──────────────────────────────────
     Shown in place of the rows/cards so the page keeps its shape while the
     boards are fetched, instead of flashing "No dashboards or reports found". */
  const SkeletonRows = () =>
    Array.from({ length: 6 }).map((_unused, i) => (
      <tr key={`dbl-sk-${i}`} className="dbl-tr">
        <td className="dbl-td">
          <div className="dbl-name-cell">
            <span className="dbl-sk dbl-sk-icon" />
            <div>
              <span className="dbl-sk dbl-sk-line" style={{ width: 150 }} />
              <span className="dbl-sk dbl-sk-line dbl-sk-badge" style={{ width: 64 }} />
            </div>
          </div>
        </td>
        <td className="dbl-td">
          <span className="dbl-sk dbl-sk-line" style={{ width: 96 }} />
        </td>
        <td className="dbl-td">
          <span className="dbl-sk dbl-sk-line" style={{ width: 80 }} />
        </td>
        <td className="dbl-td">
          <span className="dbl-sk dbl-sk-line dbl-sk-badge" style={{ width: 72 }} />
        </td>
        <td className="dbl-td">
          <span className="dbl-sk dbl-sk-line dbl-sk-badge" style={{ width: 68 }} />
        </td>
        <td className="dbl-td">
          <span className="dbl-sk dbl-sk-line" style={{ width: 112 }} />
        </td>
        <td className="dbl-td dbl-td-action">
          <span className="dbl-sk dbl-sk-dots" />
        </td>
      </tr>
    ));

  const SkeletonCards = () => (
    <div className="dbl-grid">
      {Array.from({ length: 6 }).map((_unused, i) => (
        <div key={`dbl-skc-${i}`} className="dbl-grid-card">
          <div className="dbl-grid-card-header">
            <span className="dbl-sk dbl-sk-icon" />
            <span className="dbl-sk dbl-sk-dots" />
          </div>
          <span className="dbl-sk dbl-sk-line" style={{ width: "70%" }} />
          <div className="dbl-grid-card-badges">
            <span className="dbl-sk dbl-sk-line dbl-sk-badge" style={{ width: 68 }} />
            <span className="dbl-sk dbl-sk-line dbl-sk-badge" style={{ width: 60 }} />
          </div>
          <div className="dbl-grid-card-footer">
            <span className="dbl-sk dbl-sk-line" style={{ width: 74 }} />
            <span className="dbl-sk dbl-sk-line" style={{ width: 92 }} />
          </div>
        </div>
      ))}
    </div>
  );

  /* ── Pagination ─────────────────────────────────────── */
  const Pagination = () => {
    if (filteredRows.length === 0) return null;

    const pageNumbers = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
    } else {
      pageNumbers.push(1);
      if (currentPage > 3) pageNumbers.push("...");
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
      for (let i = start; i <= end; i++) pageNumbers.push(i);
      if (currentPage < totalPages - 2) pageNumbers.push("...");
      pageNumbers.push(totalPages);
    }

    return (
      <div className="dbl-pagination">
        <span className="dbl-pagination-info">
          Showing {startIdx + 1} to {Math.min(endIdx, filteredRows.length)} of {filteredRows.length} results
        </span>
        <div className="dbl-pagination-btns">
          <button
            className="dbl-page-btn"
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
          >
            ‹
          </button>
          {pageNumbers.map((p, i) =>
            p === "..." ? (
              <span key={`ellipsis-${i}`} className="dbl-page-ellipsis">
                …
              </span>
            ) : (
              <button
                key={p}
                className={`dbl-page-btn ${currentPage === p ? "dbl-page-active" : ""}`}
                onClick={() => setCurrentPage(p)}
              >
                {p}
              </button>
            ),
          )}
          <button
            className="dbl-page-btn"
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
          >
            ›
          </button>
        </div>
      </div>
    );
  };

  /* ── Grid card */
  const GridCard = ({ row }) => (
    <div className="dbl-grid-card">
      <div className="dbl-grid-card-header">
        <TypeIcon typeLabel={row.typeLabel} />
        <ActionMenu row={row} />
      </div>
      <div className="dbl-grid-card-title dbl-name-link" onClick={() => handleViewBoard(row)}>
        {row.name}
      </div>
      <div className="dbl-grid-card-badges">
        <StatusPill statusLabel={row.statusLabel} />
        <VisibilityBadge visibility={row.visibility} />
        {row.appNames !== "—" && <span className="dbl-grid-app-tag">{row.appNames}</span>}
      </div>
      <div className="dbl-grid-card-footer">
        <span className="dbl-grid-footer-meta">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" width="12" height="12">
            <circle cx="8" cy="8" r="3" />
            <path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" />
          </svg>
          {row.typeLabel}
        </span>
        <span className="dbl-grid-footer-date">{row.createdText}</span>
      </div>
    </div>
  );

  /* ── Render ─────────────────────────────────────────── */
  return (
    <DashboardView>
      {/* The skeleton rows/cards below cover the fetch now, so the blocking overlay
          is no longer used. Kept in case we want it back. */}
      {/* {isLoading && <LoadingOverlay text="Loading dashboards..." />} */}

      {/* --grid drops the list card's frame from the pager - see DashboardList.css */}
      <div className={`dbl-shell dbl-shell--${viewMode}`} onClick={handleTableClick}>
        {/* Header */}
        <div className="dbl-header">
          <div className="dbl-header-left">
            <h1 className="dbl-title">Dashboards / Reports</h1>
            <p className="dbl-subtitle">{today}</p>
          </div>
          <button className="dbl-create-btn" onClick={() => history.push("/create-dashboard")}>
            + Create New
          </button>
        </div>

        {/* Controls */}
        <div className="dbl-controls">
          <div className="dbl-search-wrap">
            <svg
              className="dbl-search-icon"
              viewBox="0 0 20 20"
              fill="none"
              width="16"
              height="16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8.5" cy="8.5" r="5.5" stroke="#9ca3af" strokeWidth="1.5" />
              <path d="M13 13l3 3" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            <input
              className="dbl-search-input"
              type="text"
              placeholder="Search dashboards..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>

          <div className="dbl-filters">
            <select
              className="dbl-select"
              value={filterApp}
              onChange={(e) => {
                setFilterApp(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="all">All Application</option>
              {uniqueApps.map((a) => (
                <option key={a} value={a}>
                  {a}
                </option>
              ))}
            </select>

            <select
              className="dbl-select"
              value={filterGroup}
              onChange={(e) => {
                setFilterGroup(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="all">All Groups</option>
              {uniqueGroups.map((g) => (
                <option key={g} value={g}>
                  {g}
                </option>
              ))}
            </select>

            <select
              className="dbl-select"
              value={filterType}
              onChange={(e) => {
                setFilterType(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="all">All Types</option>
              <option value="dashboard">Dashboard</option>
              <option value="report">Report</option>
            </select>

            <div className="dbl-view-toggle">
              <button
                className={`dbl-toggle-btn ${viewMode === "grid" ? "active" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewModeChange("grid");
                }}
                title="Grid view"
              >
                <svg viewBox="0 0 16 16" fill="currentColor" width="15" height="15">
                  <rect x="1" y="1" width="6" height="6" rx="1" />
                  <rect x="9" y="1" width="6" height="6" rx="1" />
                  <rect x="1" y="9" width="6" height="6" rx="1" />
                  <rect x="9" y="9" width="6" height="6" rx="1" />
                </svg>
              </button>
              <button
                className={`dbl-toggle-btn ${viewMode === "list" ? "active" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewModeChange("list");
                }}
                title="List view"
              >
                <svg viewBox="0 0 16 16" fill="currentColor" width="15" height="15">
                  <rect x="1" y="2" width="14" height="2" rx="1" />
                  <rect x="1" y="7" width="14" height="2" rx="1" />
                  <rect x="1" y="12" width="14" height="2" rx="1" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* GRID VIEW */}
        {viewMode === "grid" && (
          <>
            {isLoading ? (
              <SkeletonCards />
            ) : filteredRows.length > 0 ? (
              /* data-drag-scroll: grab the card area and pan it, same as a report
                 table - see src/utils/dragToScroll.js */
              <div className="dbl-grid" data-drag-scroll>
                {paginatedRows.map((row) => (
                  <GridCard key={row.key} row={row} />
                ))}
              </div>
            ) : (
              <div className="dbl-empty-block">No dashboards or reports found.</div>
            )}
            <Pagination />
          </>
        )}

        {/* LIST VIEW */}
        {viewMode === "list" && (
          <>
            {/* data-drag-scroll: the list body pans by hand as well as by wheel */}
            <div className="dbl-table-wrap" data-drag-scroll>
              <table className="dbl-table">
                <thead className="dbl-thead">
                  <tr>
                    <th className="dbl-th">Name</th>
                    <th className="dbl-th">Application</th>
                    <th className="dbl-th">Group</th>
                    <th className="dbl-th">Type</th>
                    <th className="dbl-th">Status</th>
                    <th className="dbl-th">Created</th>
                    <th className="dbl-th dbl-th-action"></th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <SkeletonRows />
                  ) : filteredRows.length > 0 ? (
                    paginatedRows.map((row) => (
                      <tr key={row.key} className="dbl-tr">
                        <td className="dbl-td">
                          <div className="dbl-name-cell">
                            <TypeIcon typeLabel={row.typeLabel} />
                            <div>
                              {/* Clicking the name opens the board, same as the View action. */}
                              <div className="dbl-name-text dbl-name-link" onClick={() => handleViewBoard(row)}>
                                {row.name}
                              </div>
                              <VisibilityBadge visibility={row.visibility} />
                            </div>
                          </div>
                        </td>
                        <td className="dbl-td dbl-td-muted">{row.appNames}</td>
                        <td className="dbl-td dbl-td-muted">{row.groupName}</td>
                        <td className="dbl-td">
                          <TypePill typeLabel={row.typeLabel} />
                        </td>
                        <td className="dbl-td">
                          <StatusPill statusLabel={row.statusLabel} />
                        </td>
                        <td className="dbl-td dbl-td-muted">{row.createdText}</td>
                        <td className="dbl-td dbl-td-action">
                          <ActionMenu row={row} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="dbl-empty">
                        No dashboards or reports found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <Pagination />
          </>
        )}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          danger
          title={`Delete this ${pendingDelete?.typeLabel || "board"}?`}
          message={`"${pendingDelete?.name}" will be removed permanently. This cannot be undone.`}
          onCancel={() => setPendingDelete(null)}
          onConfirm={confirmDeleteBoard}
        />
      </div>
    </DashboardView>
  );
};

export default DashboardList;
